import React from "react";
import FormPollCreationWorkspace from "../components/FormPollCreationWorkspace";

/**
 * Page de création de formulaire avec IA
 * Utilise le workspace complet avec toute l'intelligence pour les formulaires
 */
export default function FormCreator() {
  return <FormPollCreationWorkspace />;
}
